<template>
  <div class="view">
    <textarea class="text-left padding-lr text-df text-black text-400 view padding-top-lg"
              readonly
              style="width:100%;height: 100vh;border-width: 0; background: transparent;resize: none;">
      {{content+'\n\n'}}
    </textarea>
  </div>
</template>

<script>
  import App from '../util/comfun'
  //import 'element-ui/lib/theme-chalk/display.css';
  export default {
    data () {
      return {
        title:'',
        content:'\t Fotoo 服务协议及隐私保护 \t\n' +
        '\n' +
        '更新日期：【2023】年【10】月【26】日 \n' +
        '\n' +
        '生效日期：【2023】年 【10】月【26】日 \n' +
        '\n' +
        '首部及导言 \n' +
        '\n' +
        '欢迎使用 Fotoo 平台软件及服务。\n' +
        '\n' +
        'Fotoo是由西安空空如也网络科技有限公司开发的一款一站式的征集、投稿、评选工具软件产品。Fotoo“活动”功能是Fotoo提供的供用户之间进行互动的工具（以下简称“本工具”）。用户可以发起一项具体的活动让其他用户进行参与，发起活动的用户简称为“发起人”，参与活动的用户简称为“参与者”。\n' +
        '\n' +
        '请注意：Fotoo对于本功能仅提供中立的技术服务，并不参与发起人使用本功能发起及实施各项具体活动的任何环节。各项具体活动是发起人以自身名义发起及实施，其活动描述、规则、内容、玩法以及活动中的任何承诺或意思表示（包括但不限于奖励、奖品、优惠、福利等）是发起人自行作出，由发起人自行承担责任，与Fotoo平台无关。\n' +
        '\n' +
        '各项具体活动的发起及实施、发起人与参与者的行为均应当遵守法律法规、平台规则，符合公序良俗，不得进行违法营销，否则Fotoo平台有权依据《Fotoo运营规范》对每项具体的活动、发起人、参与者进行处理，并有权要求赔偿对Fotoo平台造成的损失。\n' +
        '\n' +
        '使用“Fotoo”服务（以下简称“本服务”），您应当阅读并遵守《“Fotoo”服务协议及隐私保护》（以下简称“本协议”）以及专项规则等。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您对本服务的任何购买或接受赠与等获取行为及登录、查看、绑定公众号、填写信息等任何使用行为即视为您已阅读并同意受本协议的约束。\n' +
        '\n' +
        '本协议是您与“Fotoo”服务的运营者西安空空如也网络科技有限公司（以下简称本公司或我们）之间就“Fotoo”服务所订立的协议。请您仔细阅读本协议，您同意并完成购买后，本协议即构成对双方有约束力的法律文件。\n' +
        '\n' +
        '1、协议的范围\n' +
        '1.1 本协议是您与西安空空如也网络科技有限公司之间关于您使用“Fotoo”服务所订立的协议。“用户”是指注册、登录、使用“Fotoo”的个人、公司或组织，在本协议中称为“您”。\n' +
        '1.2 本协议的内容包括以下条款及本公司已经发布的或将来可能发布的各项规则，所有规\n' +
        '则为本协议不可分割的一部分，与协议正文具有同等法律效力。本协议是您与本公司共同\n' +
        '签订的，适用于您在“Fotoo”的全部活动。在您注册成为用户时，您已经阅读、理解并接受本协议的全部条款及各项规则，并承诺遵守中国的各类法律、法规、政策的规定，如有违反而导致任何法律后果的发生，您将以自己的名义独立承担所有相应的法律责任。\n' +
        '1.3 本公司有权根据相关法律、法规、政策的要求及提供服务的需要不时地修改本协议或\n' +
        '根据本协议制定、修改各类具体规则并在“Fotoo”相关系统版块发布，请您适时注意本协议及具体规则的变更。若您在本协议及具体规则内容公告变更后继续使用本服务的，表示您已经阅读、理解并接受修改后的协议和具体规则内容，也将遵循修改后的协议和具体规则使用“Fotoo”的服务；同时就您在协议和具体规则修订前通过“Fotoo”进行的交易及其效力，视为您已同意并已按照本协议及有关规则进行了相应的授权和追认。若您不同意修改后的协议内容，您应立即停止使用 “Fotoo”相关的服务。\n' +
        '1.4 您通过自行或授权有关方根据本协议及“Fotoo”有关规则、说明操作确认本协议后，本协议即在您和“Fotoo”之间产生法律效力。本协议不涉及您与“Fotoo”的其他用户之间因网上交易而产生的法律关系或法律纠纷。\n' +
        '1.5 属于微信公众帐号，在不与本协议冲突的情况下，用户应遵守《微信公众平台服务协议》 等协议规则关于微信公众帐号的其他相关规定。\n' +
        '\n' +
        '2、注册\n' +
        '2.1 在您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您以\n' +
        '其他本公司允许的方式实际使用“Fotoo”服务时，您即受本协议的约束。您可以使用您提供或确认的邮箱、手机号码或者“Fotoo”允许的其它方式作为登录手段进入“Fotoo”。\n' +
        '2.2 您了解并同意，如您在“Fotoo”完成的注册程序，只要您注册成功，您即可以获得您的登录名。您在此明确授权，您的账户信息在您注册成功时，已授权给“Fotoo”使用，以使您更便捷地使用“Fotoo”服务。\n' +
        '2.3 您可以对账户设置昵称，但您设置的昵称不得侵犯或涉嫌侵犯他人合法权益。如您设\n' +
        '置的昵称涉嫌侵犯他人合法权益的，“Fotoo”有权解除本协议，终止向您提供服务，并注销您的账户。账户注销后，相应的昵称将开放给其他有权用户登记使用。\n' +
        '2.4 您应当妥善保管用户名和密码，且需对用户名和密码的安全负全部责任，同时对以用户名进行的所有活动和事件负全责。\n' +
        '\n' +
        '3、用户使用规则\n' +
        '3.1 您在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表本公司的观点、立场或政策，本公司对此不承担任何责任。\n' +
        '3.2 您理解并同意，您不得利用“Fotoo”帐号制作、复制、发布、传播如下干扰“Fotoo”正常运营，以及侵犯其他用户或第三方合法权益的内容：\n' +
        '3.2.1制作、发布、传送、传播、储存违反国家法律法规禁止的内容：\n' +
        '（1）违反宪法的；\n' +
        '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；\n' +
        '（3）损害国家荣誉和利益的；\n' +
        '（4）煽动民族仇恨、民族歧视，破坏民族团结的；\n' +
        '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；\n' +
        '（6）散布谣言，扰乱社会秩序，破坏社会稳定的；\n' +
        '（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；\n' +
        '（8）侮辱或者诽谤他人，侵害他人合法权益的；\n' +
        '（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；\n' +
        '（10）以非法民间组织名义活动的；\n' +
        '（11）含有法律法规禁止的其他内容的。\n' +
        '3.2.2 您不得利用“Fotoo”或本服务进行如下行为：\n' +
        '(1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；\n' +
        '(2) 强制、诱导其他用户关注、点击链接页面或分享信息的；\n' +
        '(3) 虚构事实、隐瞒真相以误导、欺骗他人的；\n' +
        '(4) 利用技术手段批量建立虚假帐号的；\n' +
        '(5) 利用“Fotoo”或本服务从事任何违法犯罪活动的；\n' +
        '(6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；\n' +
        '(7)其他违反法律法规规定、侵犯其他用户合法权益、干扰“Fotoo”正常运营或本公司未明示授权的行为。\n' +
        '(8)发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利\n' +
        '的内容。\n' +
        '3.2.3 涉及他人隐私、个人信息或资料的内容。\n' +
        '3.2.4 发表、传送、传播骚扰信息、广告信息及垃圾信息或含有任何性或性暗示的内容。\n' +
        '3.2.5 违反微信平台运营规则的活动和相关内容。\n' +
        '3.2.6 其他违反法律法规、政策及公序良俗、社会公德或干扰“Fotoo”正常运营和侵犯其他用户或第三方合法权益内容的信息。\n' +
        '3.3 您有责任妥善保管注册帐号信息及帐号密码的安全，因您保管不善可能导致遭受盗号或密码失窃，全部责任由您自行承担。您需要对注册帐号以及密码下的行为承担法律责任。您同意在任何情况下不使用其他用户的帐号或密码。在您怀疑他人使用其帐号或密码时，您同意立即通知本公司。\n' +
        '3.4 本服务仅为您与参与者之间为活动而提供服务，“Fotoo”对您在活动页中提出的现金或实物类奖励、奖品以及虚拟奖励等以及您在活动结束后是否兑现奖励均不承担任何责任和义务。请您确保在“Fotoo”创建的活动真实有效，且公正公开公平，禁止以获利为目的任何虚假活动，若本公司收到参与者举报，有权立即终止您的版本权益并永久封号，本公司将提交至您所在地的执法机关处理，并保留诉讼的权利。对您的虚假行为致本公司遭受任何损失的，您需要承担给本公司造成的全部损失，包括但不限于诉讼费、律师费、执行费等一切支出费用。\n' +
        '\n' +
        '4、服务内容及版本权益\n' +
        '4.1 本公司为您提供服务和技术支持，不参与您的活动运营，任何活动纠纷和本公司无关，且本公司有权利向参与者公布活动方的联系方式。\n' +
        '4.2 本公司有权对您的注册数据及交易行为进行查阅，发现注册数据或交易行为中存在任何\n' +
        '问题，均有权向您发出询问或要求改正的通知，或者直接作出删除等处理。\n' +
        '4.3 对于您通过“Fotoo”后台发布任何违法违规信息，包括但不限于本协议第 3.1 条，本公司有权在不通知您的前提下进行删除或采取其他限制性措施。\n' +
        '4.4 当您通过注册，并升级版本时，您所享有的版本权益在您充值时权益表已列明。一旦充值成功，视为您已全部接受该版本应享有的权益，您不得在后期使用要求本公司增设列表中未列明的权益，您可以为增加用户感受提出建议，但不表示本公司有必须根据您的需要另行开发的义务。但如您有需要，我们可以为您提供另外的、有偿的开发服务或技术支持。\n' +
        '4.5请您在购买前确认功能、服务内容和条款，订购或付款一经生效后不接受任何退订和退款申请，敬请谅解。您应依照本协议在服务期限内使用本功能，服务一旦开通，Fotoo并不因您未实际使用提供其他替代或补充或退款。如您因不可抗力因素产生退费的，需缴纳当单20%的服务费，并按当单实际支付金额扣除已使用月份产生的费用进行退费，购买时的赠送、优惠、折扣等不在退费范围。\n' +
        '4.6如果您停止使用本服务、权益到期或服务被终止或取消，Fotoo可以从服务器上永久地删除您的数据。您的服务停止、到期、终止或取消后，Fotoo没有义务向您返还任何数据。\n' +
        '4.7 您使用Fotoo服务产生的所有内容，包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等数据、资料和信息，承诺仅可用于相关的合法目的及用途，不泄露和侵犯参与者的个人信息和隐私。\n' +
        '4.8 本公司有权在界面附加产品LOGO用于宣传，您无权要求删除该LOGO。\n' +
        '\n' +
        '5、知识产权\n' +
        '5.1 本公司在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表\n' +
        '等）的知识产权归本公司所有，用户在使用本服务中所产生的内容的知识产权归用户或相\n' +
        '关权利人所有。\n' +
        '5.2 除另有特别声明外，“Fotoo”提供本服务时所依托的著作权、专利权及其他知识产权均归本公司所有。\n' +
        '5.3 上述及其他任何本服务包含的内容的知识产权均受到法律保护，其他未经本公司、用户\n' +
        '或相关权利人许可的第三人，不得以任何形式进行使用或创造相关衍生作品。\n' +
        '5.4 任何未经本公司书面同意及权利人许可的非法获取行为，均属违法侵权行为。您确认并\n' +
        '同意，为及时、有效地保障您基于本服务的合法权益，您授权本公司在发现您的合法权益（包\n' +
        '括但不限于信息网络传播权、著作权等权益）可能受到侵害时，有权代为向涉嫌侵权的第三人采取法律手段进行维权，授权采取的法律手段包括但不限于发函警告、提起诉讼、申请仲裁、移送侦查机关处理等。\n' +
        '\n' +
        '6、用户个人隐私信息保护\n' +
        '6.1 您在注册帐号或使用本服务的过程中，可能需要填写或提交一些必要的信息，如法律法规规定的需要填写的身份信息。如您提交的信息不完整或不符合法律法规的规定，则可能无法使用本服务或在使用本服务的过程中受到限制。\n' +
        '6.2 个人隐私信息是指涉及您个人身份或个人隐私的信息，比如，您的真实姓名、身份证号、手机号码、手机设备识别码、IP地址、用户聊天记录。非个人隐私信息是指您对本服务的操作状态以及使用习惯等明确且客观反映在“Fotoo”的基本记录信息、个人隐私信息范围外的其它普通信息，以及您同意公开的信息。\n' +
        '6.3我们非常重视您的信息安全，并努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止您的信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高您信息的安全性，并使用受信赖的保护机制防止信息遭到恶意攻击，部署访问控制机制，尽力确保只有授权人员才可访问您的信息。非因本公司原因或经采取合理的安全措施后，您的信息仍遭受侵害的，本公司不负任何法律责任。\n' +
        '6.4 本公司未经用户同意不向任何第三方转让、公开、披露用户个人隐私信息，但以下特定情形除外：\n' +
        '(1) 本公司根据法律法规规定或有权机关的指示提供用户的个人隐私信息；\n' +
        '(2) 由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非本公司原因导致的个人隐私信息的泄露；\n' +
        '(3) 用户自行向第三方公开其个人隐私信息；\n' +
        '(4) 用户与本公司及合作单位之间就用户个人隐私信息的使用公开达成约定，本公司因此向合作单位公开用户个人隐私信息；\n' +
        '(5) 任何由于受到计算机病毒、木马或其他恶意程序、黑客攻击侵入及其他不可抗力事件导致您的个人隐私信息的泄露。\n' +
        '（6）您或本公司的电脑软件、系统、硬件和通信线路出现故障；\n' +
        '(7) 您在使用过程中存在主动散布政治有害、淫秽色情、广告、血腥暴力、诽谤侮辱、泄露个人隐私等信息。\n' +
        '6.5本公司将依赖用户提供的个人信息判断用户是否为未成年人。任何18岁以下的未成年人注册帐号或使用本服务应事先取得家长或其法定监护人（以下简称"监护人"）的书面同意。除根据法律法规的规定及有权机关的指示披露外，本公司不会使用或向任何第三方透露未成年人的聊天记录及其他个人隐私信息。除本协议约定的例外情形外，未经监护人事先同意，本公司不会使用或向任何第三方透露未成年人的个人隐私信息。\n' +
        '\n' +
        '7、责任限制和免责\n' +
        '7.1 您理解并同意，因业务发展需要，本公司保留单方面对本服务的全部或部分服务内容在\n' +
        '任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销的权利，您需承担此风险。\n' +
        '7.2本公司依据本协议约定获得处理违法违规内容或行为的权利，该权利不构成本公司的义\n' +
        '务或承诺，本公司不能保证及时发现违法违规情形或进行相应处理。\n' +
        '7.3 若本公司发现您因包括但不限于组织机构解散、注销、被吊销等任何原因导致民事行为\n' +
        '能力、民事权利能力终止的情况，为保障用户和其他主体的合法权益，将有权决定立即终止\n' +
        '本服务，且无需承担任何责任。\n' +
        '7.4因下列情形之一不能提供服务或者造成数据丢失，本公司无须承担任何责任：\n' +
        '1、由于地震、战争、洪水、国家政策等不可抗力；\n' +
        '2、由于服务器网络接入服务提供商（电信、网通、IDC机房等）原因造成的网络中断；\n' +
        '3、由于操作系统软件漏洞、病毒、黑客等因素乙方免责，但乙方应尽防范义务，包括但不限于服务器专人管理、及时安装系统更新、安装防火墙、定期数据备份等；\n' +
        '4、由于微信红包投诉、敏感视频或其他政策、法律因素暂停视频等；\n' +
        '5、因相关政府职能部门审查需要而获悉的相关信息。\n' +
        '\n' +
        '8、未成年人使用条款\n' +
        '8.1若您未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。\n' +
        '8.2未成年人用户涉世未深，容易被网络虚象迷惑，且好奇心强，遇事缺乏随机应变的处理能力，很容易被别有用心的人利用而又缺乏自我保护能力。因此，未成年人用户在使用本服务时应注意以下事项，提高安全意识，加强自我保护：\n' +
        '（1）认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活；\n' +
        '（2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰；\n' +
        '（3）在监护人或老师的指导下，学习正确使用网络；\n' +
        '（4）避免陌生网友随意会面或参与联谊活动，以免不法分子有机可乘，危及自身安全。\n' +
        '8.3监护人、学校均应对未成年人使用本服务时多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。\n' +
        '\n' +
        '\n' +
        ' 9、通知\n' +
        '9.1 您应当准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码\n' +
        '等联系方式，以便本公司或其他用户与您进行有效联系，因通过这些联系方式无法与您取\n' +
        '得联系，导致您在使用本公司服务过程中产生任何损失或增加费用的，应由您完全独自承\n' +
        '担。\n' +
        '9.2 您了解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按本公司的要求进行操作。\n' +
        '\n' +
        '10、法律适用、管辖及其他\n' +
        '10.1 本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律，如\n' +
        '无相关法律规定的，则应参照通用商业惯例和（或）行业惯例。\n' +
        '10.2 您同意本公司因经营业务需要有权将本协议项下的权利义务就部分或全部进行转让，而\n' +
        '无须再通知予您并取得您的同意。\n' +
        '10.3 因本协议或本公司服务所引起或与其有关的任何争议由本公司所在地人民法院管辖。\n' +
        '10.4本协议取代您和本公司先前就相同事项订立的任何书面或口头协议。倘若本协议任何\n' +
        '条款被裁定为无效或不可强制执行，该项条款应被撤销，而其余条款应予遵守和执行。条\n' +
        '款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。本公司未就您或其他人士的某项违约行为采取行动，并不表明本公司撤回就任何继后或类似的违约事件采取动的权利。\n' +
        '\n' +
        '西安空空如也网络科技有限公司'
      }
    },
    components:{

    },
    methods:{
      setContent(fileName){
        if('服务购买协议'==fileName){
          this.content='\t\tFotoo服务购买协议 \t\n' +
            '更新日期：2023年10月26日\n' +
            '生效日期：2023年10月26日\n' +
            '\n' +
            '欢迎你购买Fotoo服务（以下简称“本服务”）！\n' +
            '为购买和使用本服务，你应当阅读并遵守本协议，本协议为《Fotoo服务协议及隐私保护》的组成部分，本协议与《Fotoo服务协议及隐私保护》约定不一致的，以本协议约定为准。\n' +
            '本协议包含你使用本服务时所适用的条款及条件，并构成你或你所代表的实体(包括且并不限于公司、组织、机构、团体和机关等，以下简称“你”)与西安空空如也网络科技有限公司(以下简称“西安空空如也”)之间的协议。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示你注意。\n' +
            '除非你已阅读并接受本协议，否则你无权使用本服务。你线上点击确认、勾选或开通使用本服务的行为即视为你已取得你所代表的实体的授权，并已阅读且同意本协议的约束，本协议即生效。请你审慎阅读并选择接受或不接受本协议，如果你不同意本协议，请不要进行任何后续操作。\n' +
            '\n' +
            '一、定义\n' +
            '本协议中的云流量、云存储空间、下载额度、音视频转码瘦身、微信手机号授权次数、短信包、图片瘦身、文档瘦身、官方认证等服务内容以订单订购页面为准。\n' +
            '\n' +
            '二、服务订购、费用与支付\n' +
            '2.1 西安空空如也将在Fotoo官网公布本服务的计费模式、价格体系等信息，具体的计费以订单订购页面显示的当时有效的计费模式和标准为准。\n' +
            '2.2 你应在订购本服务时按照订购页面要求一次性向西安空空如也支付全部服务费用，西安空空如也收到你支付的费用后及时向你提供服务。西安空空如也有权在你未按约定支付费用时暂停或终止向你提供服务或技术支持。同时，西安空空如也对后付费服务中的欠费行为保留追究法律责任的权利。\n' +
            '2.3 服务期满若双方愿意继续合作，你应在服务期满前进行续费并支付续费款项，以使服务得以继续正常进行。如续费时西安空空如也对产品体系、名称、价格、计费模式等进行调整的，双方同意按照届时有效的新产品体系、名称、价格、计费模式等履行。\n' +
            '2.4 你理解并同意，西安空空如也有权根据实际情况，不定期的对本服务的产品体系、名称、价格、计费模式等进行调整。西安空空如也将在合理范围内的尽最大努力，将前述调整及变化通过Fotoo官网通知、消息等一种或多种方式提前告知你。若你不同意前述服务的调整及变化，则应停止使用本服务。\n' +
            '\n' +
            '三、权利与义务\n' +
            '3.1 你承诺并保证：\n' +
            '3.1.1  你提交的所有信息资料真实、准确、完整、合法有效，且你对信息资料的真实性、合法性、准确性和有效性承担责任。\n' +
            '3.1.2 你签署、履行本协议，和/或使用本服务不违反任何可适用的法律法规或对其有约束力的法律文件的限制，不得从事任何非法业务。\n' +
            '3.1.3 你拥有签署和履行本协议之完全的民事权利能力、民事行为能力和/或相关权限并已采取一切必要的行动或公司行动取得正式授权以签署和履行本协议。\n' +
            '3.2 本服务属于消耗性服务产品，除出现可归责于西安空空如也的原因，导致用户无法使用服务的情形外，其他情形不支持退款，因你自身原因导致服务不可用，例如违反账号使用规则导致账号被限制使用的，不支持退款。\n' +
            '3.3 你理解并知悉，你购买的服务仅能在你购买服务时所登录的用户ID中使用。\n' +
            '\n' +
            '四、协议期限\n' +
            '4.1 本服务的有效期以订单页面显示的为准，请你注意：\n' +
            '4.2 西安空空如也应为你提供协议生效时订单列明的所有服务。你充分理解，西安空空如也在协议生效后可能进行服务变更，包括但不限于服务升级、服务停用等。\n' +
            '4.3 西安空空如也将在协议期满前通过消息向你发送提醒，若你希望继续使用本服务，请你在期满前及时进行续购；如你未及时进行续费的，你将无法继续使用本服务。\n' +
            '\n' +
            '五、服务终止\n' +
            '5.1 若发生下列情形，西安空空如也有权终止为你提供本服务，且无需承担任何责任：\n' +
            ' 1) 双方协商一致终止服务；\n' +
            ' 2) 你违反法律规定或本协议的约定，包括但不限于：\n' +
            'a.你未按照本须知的约定履行付款义务；\n' +
            'b.你违反本协议中所做的承诺等，西安空空如也有权单方面终止服务，并且不退还你已经支付的费用。\n' +
            '5.2 任何情况下，西安空空如也基于本协议及相关订单和服务向你所承担的赔偿责任（无论基于合同、侵权或任何其他责任理论）的总额（若有），不超过西安空空如也向你提供服务已经收取费用的总额。\n' +
            '5.3 你承诺不将本服务任何部分之使用用于二次商业行为，包括转售及任何其它商业目的。\n' +
            '\n' +
            '六、免责条款\n' +
            '6.1 若因为系统故障、网络故障或其他原因导致延迟购买服务，西安空空如也将在故障排除后再为你提供相关服务。西安空空如也不承担延迟购买的相关责任和后果。\n' +
            '6.2 西安空空如也会尽其商业上的合理努力保障你能够正常使用本服务，但是由于本服务涉及到互联网及电信网络等相关通信服务，可能会受到不稳定或无法预知之因素（包括但不限于：计算机病毒或黑客攻击、系统不稳定、你所在位置、你关机、通信网络问题、互联网络问题及其他不可抗拒因素）的影响导致服务中断或服务无法满足你要求。基于此，西安空空如也对本服务的连续性、稳定性、及时性、安全性不作任何担保。因上述原因而带来的风险及损失，均由你自行承担。\n' +
            '6.3 为保障本服务的流畅性，西安空空如也或运营商会不定期对系统进行维护、升级，本服务在此期间可能无法正常使用，因此带来的风险及损失，均由你自行承担。\n' +
            '6.4 根据有关规定，如果司法、行政机关或第三方提出数据涉嫌违法或侵权等理由，西安空空如也在接到通知后有权依照第三方的要求进行删除，且无需承担任何法律责任。\n' +
            '6.5 上述情形导致本服务使用暂停或者终止，西安空空如也将不会退还已收取的费用，因此带来的风险及损失，均由你自行承担。\n' +
            '\n' +
            '七、协议变更\n' +
            '西安空空如也可根据具体情况不时对本服务进行商业上合理的修改或变更。在下述任一情形下，西安空空如也可能会修改、移除或终止任何或全部本服务内容:\n' +
            '1）本服务受到适用的相关法律法规、规章制度和/或监管部门的规定或其他要求的约束;\n' +
            '2）由于可适用的法律法规、规章制度和/或政府监管部门的规定或其他要求，西安空空如也认为本服务或本协议相关规定与此类存在冲突;\n' +
            '3）西安空空如也基于公司战略调整、产品运营策略或产品需求变更等原因对本服务作出相应的修改或终止本服务。\n' +
            '若本服务发生任何重大修改或终止，西安空空如也将通过Fotoo官网、消息等一种或多种方式提前通知你。若你继续使用本服务，则视为你接受西安空空如也所做的相关修改；若你不同意相关修改的，你有权选择停止使用本服务。若因本条款约定导致本服务终止或你不同意相关修改的，西安空空如也会折算服务停止时间到你原订单结束时间的剩余价值，计算你的退款金额。\n' +
            '\n' +
            '八、其他\n' +
            '8.1本协议以及以引述方式等纳入其中的协议和西安空空如也相关制度规范(以及西安空空如也根据本协议不时更新修订的政策及协议，统称为“通用服务协议”)，构成你与西安空空如也之间就西安空空如也会员服务达成的完整协议。如本协议与任何协议中所列明条款有不一致之处，以本协议为准。本协议未尽事宜，适用通用服务协议的规定。\n' +
            '8.2在本协议项下一方向对方提供的任何资料、技术或技术支持、软件、服务等的知识产权均属于提供一方或其合法权利人所有。除提供方或合法权利人事先书面同意，另一方无权复制、传播、转让、许可或提供他人使用上述知识成果，否则应承担相应的责任。\n' +
            '8.3 本协议签订地为中华人民共和国广东省深圳市南山区。\n' +
            '8.4 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国(不包括香港、澳门、台湾地区)法律(不包括冲突法)。\n' +
            '8.5 若你和西安空空如也之间就本协议的理解与执行发生任何纠纷或争议，首先应友好协商解决;协商不成的，双方均有权将纠纷或争议提交本协议签订地有管辖权的人民法院解决。\n' +
            '8.6 本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。\n' +
            '8.7 本协议项下之知识产权条款、法律适用及争议解决条款等内容，不因本协议的终止而失效。（完）\n' +
            '西安空空如也网络科技有限公司'
        }
      },
    },
    mounted(){
      //console.log(this.$route.params)
      this.setContent(this.$route.params.fileName)
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/document.vue